export default __webpack_public_path__ + "static/media/print.1f0f1aac.svg";